//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.service('CollectionsApiService', [
    '$http',
    '$q',
    'PromiseService',
    'RestBaseUrl',
    function(
            $http,
            $q,
            PromiseService,
            RestBaseUrl,
        ) {
            /**
             * Retrieve all collections.
             * @return {Object} Returns a promise that resolves with an array of all collections.
             */
      this.getAllCollections = function(collectionType) {
        const params = {
          collectionType,
        };

        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/collections`, { params }));
      };

            /**
             * Get a specific collection by id.
             * @param {Object} collectionId
             * @return {Object} Returns a promise.
             */
      this.getCollectionByIdAsync = function(collectionId) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/collections/${collectionId}`));
      };

      this.saveCollectionsSettingsAsync = function(collectionId, params) {
        return PromiseService.processHttpResponse($http.put(`${RestBaseUrl}/collections/${collectionId}`, params));
      };

      this.updateCollectionNameAsync = function(collectionId, name) {
        const params = {
          name,
        };

        return PromiseService.processHttpResponse($http.put(`${RestBaseUrl}/collections/${collectionId}/name`, params));
      };

      this.createCollectionAsync = function(params) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/collections`, params));
      };

      this.deleteCollectionAsync = function(collectionId) {
        return PromiseService.processHttpResponse($http.delete(`${RestBaseUrl}/collections/${collectionId}`));
      };

      this.addItemToCollectionAsync = function(collectionId, partialUniversalItemId) {
        const params = {
          itemId: partialUniversalItemId,
        };

        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/collections/${collectionId}/items`, params));
      };

      this.addSourceToCollectionAsync = function(collectionId, sourceId, sourceType, secondarySourceId) {
        const params = {
          sourceId,
          sourceType,
          secondarySourceId,
          network: 'Instagram',
        };

        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/collections/${collectionId}/sources`, params));
      };

      this.removeItemFromCollectionAsync = function(collectionId, partialUniversalItemId) {
        return PromiseService.processHttpResponse($http.delete(`${RestBaseUrl}/collections/${collectionId}/items/${partialUniversalItemId}`));
      };

      this.searchSourceSuggestions = function(collectionId, sourceType, searchString) {
        const params = {
          q: searchString,
        };

        return PromiseService.processHttpResponse(
                    $http.get(`${RestBaseUrl}/collections/${collectionId}/sources/${sourceType}/suggestions`, { params }),
                );
      };
    },
  ]);
})();
